<app-intro-section [introSection]="introSection">
</app-intro-section>
<app-selectable-content *ngIf="content" [content]="content"></app-selectable-content>